import { render, staticRenderFns } from "./CRUDTableNew.vue?vue&type=template&id=22191cca"
import script from "./CRUDTableNew.vue?vue&type=script&lang=js"
export * from "./CRUDTableNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports